import React from 'react';
import { type FinderVehicleFieldSectionProps } from '../shared';
import NumberUnitSection from './NumberUnitSection';

const FuelConsumptionSection = ({ labelPrefix, formPrefix }: FinderVehicleFieldSectionProps) => (
    <>
        <NumberUnitSection
            formPrefix={`${formPrefix}.kilometersPerLiter`}
            labelPrefix={`${labelPrefix}KilometersPerLiter`}
        />
        <NumberUnitSection
            formPrefix={`${formPrefix}.litersPer100Kilometer`}
            labelPrefix={`${labelPrefix}LitersPer100Kilometer`}
        />
        <NumberUnitSection
            formPrefix={`${formPrefix}.milesPerGallonUK`}
            labelPrefix={`${labelPrefix}MilesPerGallonUK`}
        />
    </>
);

export default FuelConsumptionSection;
